import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b507c7de&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b507c7de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b507c7de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b507c7de')) {
      api.createRecord('b507c7de', component.options)
    } else {
      api.reload('b507c7de', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b507c7de&scoped=true", function () {
      api.rerender('b507c7de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hsycjklssj/index.vue"
export default component.exports